import { render, staticRenderFns } from "./ModalViewLab400.vue?vue&type=template&id=72eea9d2"
import script from "./ModalViewLab400.vue?vue&type=script&lang=js"
export * from "./ModalViewLab400.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports